import { Component, Input, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-widgets',
  templateUrl: './widgets.component.html',
  styleUrls: ['./widgets.component.scss'],
})
export class WidgetsComponent implements OnInit {
  @Input() userId: string;
  @Input() role: string;
  @Input() regionId: string = 'no_value';
  @Input() showPrices: boolean;
  @Input() cartProducts: any[];
  @Input() section: any;
  @Input() index: number;
  useThumb: boolean;

  constructor(private platform: Platform) { }

  ngOnInit() {
    this.getDeviceWidth();
  }

  getDeviceWidth() {
    if (this.platform.width() <= 400) {
        this.useThumb = true;
    } else {
        this.useThumb = false;
    }
}


}